import $ from 'jquery';

export default function initLoginSlider() {
  $(() => {
    const $loginSlider = $('.c-login-slider');

    if ($loginSlider.length) {
      Promise.all([
        import(/* webpackChunkName: "slick" */ 'slick-carousel'),
        import(/* webpackChunkName: "slick" */ 'slick-carousel/slick/slick.css'),
      ]).then(() => {
        $loginSlider.slick({
          autoplay: true,
          autoplaySpeed: 6000,
          speed: 1000,
          arrows: false,
          dots: false,
          fade: true,
          infinite: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          draggable: false,
          swipe: false,
          touchMove: false,
        });
      });
    }
  });
}
